module.exports = __webpack_public_path__ + "static/media/cha@3x.9da54d7b.png";